<template>
    <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-mt-3">
        <div class="ppv2-grid ppv2-grid-cols-1 sm:ppv2-grid-cols-2 md:ppv2-grid-cols-3 ppv2-gap-[18px]">
            <ConfigurationCard
                v-for="card in configurationCards"
                :key="card.id"
                v-bind="card"
                @card-action="handleCardAction(card)"
            />
        </div>
    </div>
</template>

<script>
import ConfigurationCard from '../../Shared/ConfigurationCard.vue'

export default {
    name: 'EstablishmentDefault',
    components: {
        ConfigurationCard,
    },
    data() {
        return {
            title: this.$t('configuration.title'),
            subtitle: this.$t('configuration.subtitle'),
            description: this.$t('configuration.description'),
            infoMessage: '' /* this.$t('configuration.infoMessage'), */,
            progressPercentage: 45,
        }
    },

    computed: {
        configurationCards() {
            return [
                {
                    id: 1,
                    title: this.$t('configuration.cards.establishment.title'),
                    description: this.$t('configuration.cards.establishment.description'),
                    status: 'completed', // incomplete, completed, completed
                    percentage: 100,
                    buttonText: this.$t('configuration.cards.establishment.button'),
                    buttonStyle: 'secondary',
                    iconSrc: '/v2/images/Group 1000004873.png',
                },
                {
                    id: 2,
                    title: this.$t('configuration.cards.schedule.title'),
                    description: this.$t('configuration.cards.schedule.description'),
                    status: 'completed',
                    percentage: 100,
                    buttonText: this.$t('configuration.cards.schedule.button'),
                    buttonStyle: 'secondary',
                    iconSrc: '/v2/images/Group 1000004874.png',
                },
                {
                    id: 3,
                    title: this.$t('configuration.cards.billing.title'),
                    description: this.$t('configuration.cards.billing.description'),
                    status: 'completed',
                    percentage: 100,
                    buttonText: this.$t('configuration.cards.billing.button'),
                    buttonStyle: 'secondary',
                    iconSrc: '/v2/images/Vector.png',
                },
                {
                    id: 4,
                    title: this.$t('configuration.cards.legal.title'),
                    description: this.$t('configuration.cards.legal.description'),
                    status: 'completed',
                    percentage: 100,
                    buttonText: this.$t('configuration.cards.legal.button'),
                    buttonStyle: 'secondary',
                    iconSrc: '/v2/images/done.png',
                    disabled: true,
                },
                {
                    id: 5,
                    title: this.$t('configuration.cards.rules.title'),
                    description: this.$t('configuration.cards.rules.description'),
                    status: 'completed',
                    percentage: 100,
                    buttonText: this.$t('configuration.cards.rules.button'),
                    buttonStyle: 'secondary',
                    iconSrc: '/v2/images/Group 1000004876.png',
                },
            ]
        },
    },

    methods: {
        handleCardAction(card) {
            this.$emit('card-action', card)
        },
    },
}
</script>
